import React, { useState, useEffect } from "react";
import { func, string, arrayOf, shape, number } from "prop-types";
import cx from "classnames";

import useClickAway from "../../common/useClickAway.js";

import Icon from "../Icon/Icon.jsx";

const propTypes = {
  filterLabel: string,
  label: string.isRequired,
  id: string,
  values: arrayOf(
    shape({
      name: string.isRequired,
      id: string.isRequired,
      count: number,
    }),
  ).isRequired,
  onFacetChange: func.isRequired,
};

const FilterDropdownSingle = (props) => {
  const { filterLabel, label, values, id, onFacetChange } = props;

  const [isOpen, setOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const filterDropdownRef = useClickAway({ isOpen, setOpen });

  useEffect(() => {
    const selectedFacet = values.find((value) => value.selected);
    setSelectedLabel(
      selectedFacet ? `${selectedFacet.name} (${selectedFacet.count})` : label,
    );
  }, [values, label]);

  const handleSelectChange = (id, value) => {
    if (value.selected) {
      onFacetChange(id, "");
    } else {
      onFacetChange(id, value.id);
    }
    setSelectedLabel(value.selected ? label : `${value.name} (${value.count})`);
    setOpen(false);
  };

  const handleKeyPress = (event, id, value) => {
    if (event.key === "Enter") {
      handleSelectChange(id, value);
    }
  };

  const renderGroup = (values) => {
    return (
      values &&
      values.map((value) => {
        return (
          <li key={value.id} className="filter-dropdown__item">
            <input
              type="checkbox"
              className="filter-dropdown__checkbox sr-only"
              id={value.id}
              checked={value.selected}
              onKeyUp={(e) => handleKeyPress(e, id, value)}
              onChange={() => handleSelectChange(id, value)}
              data-gtm-element="dcl filter"
            />
            <label
              htmlFor={value.id}
              className={cx(
                "filter-dropdown__single-option sc-form-item__label",
                {
                  "filter-dropdown__single-option--selected": value.selected,
                },
              )}
            >
              <span>{`${value.name} (${value.count})`}</span>
              {value.selected && (
                <Icon
                  className="filter-dropdown__selected-icon"
                  iconName="close"
                  title="Selected"
                />
              )}
            </label>
          </li>
        );
      })
    );
  };

  return (
    <section
      ref={filterDropdownRef}
      className={"filter-dropdown filter-dropdown--single"}
    >
      {filterLabel ? (
        <div
          id={`filter-${label}-${id}`.replace(/\s/g, "")}
          className="filter-dropdown__eyebrow"
        >
          {label}
        </div>
      ) : null}
      <div className="filter-dropdown__header">
        <button
          aria-labelledby={`filter-${label}-${id}`.replace(/\s/g, "")}
          aria-expanded={isOpen}
          type="button"
          id={id}
          onClick={() => setOpen(!isOpen)}
          className="filter-dropdown__open-button"
          data-gtm-element="dcl filter dropdown"
        >
          <span>
            <span className="filter-dropdown__filter-text-wrapper">
              {selectedLabel !== null
                ? selectedLabel
                : filterLabel
                  ? `${filterLabel} ${label}`
                  : `${label}`}
            </span>
          </span>
        </button>
      </div>
      <div
        className={cx("filter-dropdown__panel", {
          "filter-dropdown__panel--is-open": isOpen,
        })}
      >
        <div className="filter-dropdown__menu-list">
          <ul className="filter-dropdown__group" aria-label={label}>
            {renderGroup(values)}
          </ul>
        </div>
      </div>
    </section>
  );
};
FilterDropdownSingle.propTypes = propTypes;
export default FilterDropdownSingle;
